import { ActionPayload } from "../../common/Base";
import { AuthInfoType, UPDATE_AUTH_INFO_TYPE } from "./Type";

export const updateAuthInfoDropdown = (authInfo: AuthInfoType): ActionPayload<AuthInfoType> => ({
    type: UPDATE_AUTH_INFO_TYPE,
    payload: authInfo
});
